import { Resource } from "../resource/Resource";
import { SketonOptimise } from "./optimize/SketonOptimise";
import { Material } from "../resource/Material";
import { SpineShaderInit } from "./material/SpineShaderInit";
import { Texture2D } from "../resource/Texture2D";
import { ShaderDefines2D } from "../webgl/shader/d2/ShaderDefines2D";
export class SpineTemplet extends Resource {
    constructor() {
        super();
        this.materialMap = new Map();
        this.hasPhysics = false;
        this.mainBlendMode = 0;
        this._premultipliedAlpha = true;
        this._textures = {};
        this.sketonOptimise = new SketonOptimise();
    }
    get _mainTexture() {
        let i = 0;
        let tex;
        for (let k in this._textures) {
            tex = this._textures[k];
            if (tex) {
                i++;
                if (i > 1) {
                    return null;
                }
            }
        }
        return tex;
    }
    get premultipliedAlpha() {
        return this._premultipliedAlpha;
    }
    get basePath() {
        return this._basePath;
    }
    getMaterial(texture, blendMode) {
        if (!texture) {
            console.error("SpineError:cant Find Main Texture");
            texture = Texture2D.whiteTexture;
        }
        let key = texture.id + "_" + blendMode;
        let mat = this.materialMap.get(key);
        if (!mat) {
            mat = new Material();
            mat.setShaderName("SpineStandard");
            SpineShaderInit.initSpineMaterial(mat);
            mat.setTextureByIndex(SpineShaderInit.SpineTexture, texture);
            if (texture.gammaCorrection != 1) {
                mat.addDefine(ShaderDefines2D.GAMMATEXTURE);
            }
            else {
                mat.removeDefine(ShaderDefines2D.GAMMATEXTURE);
            }
            SpineShaderInit.SetSpineBlendMode(blendMode, mat, this._premultipliedAlpha);
            if (this._premultipliedAlpha) {
                mat.addDefine(SpineShaderInit.SPINE_PREMULTIPLYALPHA);
            }
            else {
                mat.removeDefine(SpineShaderInit.SPINE_PREMULTIPLYALPHA);
            }
            mat._addReference();
            this.materialMap.set(key, mat);
        }
        return mat;
    }
    getTexture(name) {
        return this._textures[name];
    }
    setTexture(name, tex) {
        this._textures[name] = tex;
    }
    _parse(desc, atlas, textures, premultipliedAlpha = true) {
        var _a;
        let atlasLoader = new spine.AtlasAttachmentLoader(atlas);
        if (desc instanceof ArrayBuffer) {
            let skeletonBinary = new spine.SkeletonBinary(atlasLoader, false);
            this.skeletonData = skeletonBinary.readSkeletonData(new Uint8Array(desc));
        }
        else {
            let skeletonJson = new spine.SkeletonJson(atlasLoader, false);
            this.skeletonData = skeletonJson.readSkeletonData(desc);
        }
        this._textures = textures;
        this._atlas = atlas;
        this.mainBlendMode = ((_a = this.skeletonData.slots[0]) === null || _a === void 0 ? void 0 : _a.blendMode) || 0;
        this.mainTexture = this._mainTexture;
        this.width = this.skeletonData.width;
        this.height = this.skeletonData.height;
        this.offsetX = this.skeletonData.x;
        this.offsetY = this.skeletonData.y;
        this._premultipliedAlpha = premultipliedAlpha;
        this.hasPhysics = this.skeletonData.physicsConstraints && this.skeletonData.physicsConstraints.length > 0;
        this.sketonOptimise.canCache = this.sketonOptimise.canCache && !this.hasPhysics;
        this.sketonOptimise.checkMainAttach(this.skeletonData);
    }
    getAniNameByIndex(index) {
        let tAni = this.skeletonData.getAnimationByIndex(index);
        if (tAni)
            return tAni.name;
        return null;
    }
    findAnimation(name) {
        return this.skeletonData.findAnimation(name);
    }
    getSkinIndexByName(skinName) {
        return this.skeletonData.getSkinIndexByName(skinName);
    }
    _disposeResource() {
        this.sketonOptimise.destroy();
        for (let k in this._textures) {
            let tex = this._textures[k];
            if (tex) {
                tex._removeReference();
            }
        }
        if (this._referenceCount <= 0) {
            this.materialMap.forEach(value => {
                value._removeReference();
            });
            this.materialMap.clear();
        }
        else {
            console.error("SpineTemplet is using");
        }
        this.skeletonData = null;
        this.sketonOptimise = null;
    }
}
SpineTemplet.RuntimeVersion = "3.8";
